export const MINUTE_IN_MILLISECONDS = 60 * 1000;
export const FIVE_MINUTES_IN_MILLISECONDS = 5 * MINUTE_IN_MILLISECONDS;
export const TWENTY_MINUTES_IN_MILLISECONDS = 20 * MINUTE_IN_MILLISECONDS;
